import ECheckPermissions from './ECheckPermissions';
import { connect } from 'react-redux';

import {
    dashboardViewActions,
    dashboardViewEcheckDisabledUsersSel,
    dashboardViewIsPendingSel,
    dashboardViewErrorSel,
    dashboardViewHasSucceedSel
  } from 'src/store/modules/dashboardview'; 
import { accountsPaginationSel, accountsSel, userActions } from 'src/store/modules/user';

const mapStateToProps = (state: any) => {
  return {
    echeckDisabledUsers: dashboardViewEcheckDisabledUsersSel(state),
    isPending: dashboardViewIsPendingSel(state),
    hasError: dashboardViewErrorSel(state).hasFailed,
    errorMessage: dashboardViewErrorSel(state).message,
    hasSucceed: dashboardViewHasSucceedSel(state),
  };
};

const mapDispatchToProps = (dispatch: any): IDispatchFromProps => ({
  fetchEcheckDisabledUsers: () =>
    dispatch(dashboardViewActions.fetchEcheckDisabledUsers()),
    EcheckUserStatusToggle: (
      usernameArray: string[],
      status: boolean,
    ) =>
      dispatch(
        dashboardViewActions.EcheckUserStatusToggle(
          usernameArray, 
          status
        )
      ),
    onClearAlert: () => {
        dispatch(dashboardViewActions.setError());
        dispatch(dashboardViewActions.setHasSucceed(false));
      },
});

export const pureComponent = ECheckPermissions;
export default connect(mapStateToProps, mapDispatchToProps)(ECheckPermissions);

interface IDispatchFromProps {
    fetchEcheckDisabledUsers(): void;
    EcheckUserStatusToggle(
      usernameArray: string[],
      status: boolean,
    ): void;
    onClearAlert(): void;
}
